import { StandardEvents } from '@shopify/events';

/**
 * Bodysocks mobile add-to-basket toast.
 *
 * On mobile the cart drawer is intentionally NOT auto-opened (see
 * cart-drawer.js) because it's disruptive; this small toast is the add
 * confirmation instead. Desktop continues to use the drawer, so the toast
 * stays hidden there (gated in both JS and CSS).
 */
class CartToast extends HTMLElement {
  /** @type {number | null} */
  #timer = null;

  /** @type {number | null} */
  #hideTimer = null;

  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    this.querySelector('.cart-toast__close')?.addEventListener('click', this.#hide);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    if (this.#timer) clearTimeout(this.#timer);
    if (this.#hideTimer) clearTimeout(this.#hideTimer);
  }

  /** @param {{ action?: string }} event */
  #onCartUpdate = (event) => {
    // Only on an add, and only on mobile — desktop opens the drawer instead.
    if (event?.action !== 'add') return;
    if (window.matchMedia('(min-width: 750px)').matches) return;
    this.#show();
  };

  #show = () => {
    if (this.#hideTimer) {
      clearTimeout(this.#hideTimer);
      this.#hideTimer = null;
    }
    this.hidden = false;
    // Force a reflow so the transition runs from the hidden state.
    void this.offsetWidth;
    this.classList.add('cart-toast--visible');
    if (this.#timer) clearTimeout(this.#timer);
    this.#timer = window.setTimeout(this.#hide, 4000);
  };

  #hide = () => {
    if (this.#timer) {
      clearTimeout(this.#timer);
      this.#timer = null;
    }
    this.classList.remove('cart-toast--visible');
    // Remove from the layout only after the fade-out transition completes.
    this.#hideTimer = window.setTimeout(() => {
      if (!this.classList.contains('cart-toast--visible')) this.hidden = true;
      this.#hideTimer = null;
    }, 300);
  };
}

if (!customElements.get('cart-toast')) {
  customElements.define('cart-toast', CartToast);
}
